// TODO - remove becouse of legacy

import { Selector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'
import { AdSpendReportRow } from '../types'

export const reportRowsSelector: Selector<ReduxState, AdSpendReportRow[] | null> = (state) => state.adSpends.reportRows
export default reportRowsSelector
